import { Type } from 'class-transformer';
import { Model } from '../base.model';
import { Event } from '../event/event.model';

export class Home extends Model {
  @Type(() => Event)
  public shoppings: Event[];
}
